import React from 'react';
import { Colors, RuleColorCode } from './Context';
import Color from './Color.json';
import RuleColor from './RuleColor.json';

const Provider = ({ children }) => {
           // Extracting the 'red' color array from Color.json
           let colorValueRed = Color && Color.colors && Color.colors.red;
           let colorValueblue = Color && Color.colors && Color.colors.blue;
           let colorValuegreen = Color && Color.colors && Color.colors.green;
           let colorValueYellow = Color && Color.colors && Color.colors.Yellow;
           let colorValueGrey = Color && Color.colors && Color.colors.Grey;
           let colorValueFancy = Color && Color.colors && Color.colors.Fancy;
           let colorValuePrimary = RuleColor && RuleColor.colors && RuleColor.colors.Primary;
           let colorValueNeutral = RuleColor && RuleColor.colors && RuleColor.colors.Neutral;
           let colorValueFunctional=RuleColor && RuleColor.colors && RuleColor.colors.Functional;


           return (
                      <div>
                                 {/* Assuming that Colors.Provider and RuleColorCode.Provider are components */}
                                 <Colors.Provider value={{colorValueRed,colorValueblue,colorValuegreen,colorValueYellow,colorValueGrey,colorValueFancy}}>
                                            <RuleColorCode.Provider value={{colorValuePrimary, colorValueNeutral, colorValueFunctional }} >
                                                       {children}
                                            </RuleColorCode.Provider>
                                 </Colors.Provider>
                      </div>
           );
};

export default Provider;
